import { render, staticRenderFns } from "./common.vue?vue&type=template&id=8aa57760&scoped=true&"
var script = {}
import style0 from "./common.vue?vue&type=style&index=0&id=8aa57760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa57760",
  null
  
)

export default component.exports